import React from "react";
import { useAccessWindowSize } from "../../../common/layout/useAccessWindowSize";
import { Ad } from "./Ad";

export function Advertising({
	advertisingCodes = [],
}: {
	advertisingCodes?: string[];
}) {
	const { isMobile } = useAccessWindowSize();

	if (isMobile) {
		return null;
	}

	return (
		<section className="search-results-ads">
			{advertisingCodes.map((code) => (
				<Ad key={code} code={code} />
			))}
		</section>
	);
}
